// Casper Wallet utility for connect/disconnect and getting public key
// Requires: casper-js-sdk (only if you're building/signing deploys)

// Timeout (in ms) for requests to the extension [DEFAULT: 30 min]
const REQUESTS_TIMEOUT_MS = 30 * 60 * 1000;

export const getProvider = () => {
    let providerConstructor = window.CasperWalletProvider;
    if (providerConstructor === undefined) {
        return;
    }
    let provider = providerConstructor({
        timeout: REQUESTS_TIMEOUT_MS
    });
    return provider;
};

export const connectToWallet = async (setPublicKey) => {
    const provider = getProvider();
    if (!provider) return;
    try {
        const connected = await provider.requestConnection();
        if (!connected) {
            alert("Couldn't connect to wallet");
        } else {
            try {
                const publicKey = await provider.getActivePublicKey();
                setPublicKey(publicKey);
            } catch (error) {
                alert(error.message);
            }
        }
    } catch (error) {
        alert(error.message);
    }
};

export const disconnect = async (setPublicKey) => {
    const provider = getProvider();
    if (!provider) return;
    try {
        const disconnected = await provider.disconnectFromSite();
        if (disconnected) {
            setPublicKey(null);
            alert("Disconnected");
        }
    } catch (error) {
        alert(error.message);
    }
};

export const getCasperPublicKey = async () => {
    const provider = getProvider();
    if (!provider) return null;
    try {
        return await provider.getActivePublicKey();
    } catch (err) {
        console.error('Error getting public key:', err);
        return null;
    }
};
